/**
 * Husleie.no API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 1.0
 * Contact: devops+api@husleie.no
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */


import ApiClient from "../ApiClient";
import DefaultErrorResponseScheme from '../model/DefaultErrorResponseScheme';
import InlineObject3 from '../model/InlineObject3';
import InlineObject4 from '../model/InlineObject4';
import InlineObject5 from '../model/InlineObject5';
import InlineObject6 from '../model/InlineObject6';
import InlineObject7 from '../model/InlineObject7';
import InlineObject8 from '../model/InlineObject8';
import InlineResponse2003 from '../model/InlineResponse2003';
import InlineResponse2003Upsale from '../model/InlineResponse2003Upsale';
import InlineResponse2004 from '../model/InlineResponse2004';
import InlineResponse2005 from '../model/InlineResponse2005';
import InlineResponse2006 from '../model/InlineResponse2006';
import InlineResponse2007 from '../model/InlineResponse2007';
import InlineResponse2008 from '../model/InlineResponse2008';
import InlineResponse2009 from '../model/InlineResponse2009';

/**
 * Contract service.
 * @module api/ContractApi
 * @version 1.0
 */
export default class ContractApi {

    /**
     * Constructs a new ContractApi. 
     * @alias module:api/ContractApi
     * @class
     * @param {module:ApiClient} [apiClient] Optional API client implementation to use,
     * default to {@link module:ApiClient#instance} if unspecified.
     */
    constructor(apiClient) {
        this.apiClient = apiClient || ApiClient.instance;
    }


    /**
     * Callback function to receive the result of the contractDownload operation.
     * @callback module:api/ContractApi~contractDownloadCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Generates and offers the contract as a PDF-file for download. See download_token for generating the required token.
     * Generates and offers the contract as a PDF-file for download.
     * @param {String} id 
     * @param {String} token 
     * @param {module:api/ContractApi~contractDownloadCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */
    contractDownload(id, token, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractDownload");
        }

        // verify the required parameter 'token' is set
        if (token === undefined || token === null) {
            throw new Error("Missing the required parameter 'token' when calling contractDownload");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {
            'token': token
        };
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['application/pdf'];
        let returnType = File;

        return this.apiClient.callApi(
            '/contract_session/{id}/download', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the contractFeedback operation.
     * @callback module:api/ContractApi~contractFeedbackCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2007} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This will send the contract back to the landlord with feedback from tenant.
     * This method will cancel the signing process and send the contract back to the landlord
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject4} opts.feedback 
     * @param {module:api/ContractApi~contractFeedbackCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2007}
     */
    contractFeedback(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['feedback'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractFeedback");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2007;

        return this.apiClient.callApi(
            '/contract_session/{id}/feedback', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the contractPreview operation.
     * @callback module:api/ContractApi~contractPreviewCallback
     * @param {String} error Error message, if any.
     * @param {File} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Get a preview of the contract, based on the information in the contract session
     * Get a preview of the contract, based on the information in the contract session
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/String} opts.format  (default to &#39;html&#39;)
     * @param {module:api/ContractApi~contractPreviewCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link File}
     */
    contractPreview(id, opts, callback) {
        opts = opts || {};
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractPreview");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {
            'format': opts['format']
        };
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['application/pdf', 'text/html'];
        let returnType = File;

        return this.apiClient.callApi(
            '/contract_session/{id}/preview', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the contractSendForSigning operation.
     * @callback module:api/ContractApi~contractSendForSigningCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2007} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * This will send the contract to the tenant for signing.
     * This method will start the signing procedure by sending tenant a mail with a link for signing the contract
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject5} opts.callback 
     * @param {module:api/ContractApi~contractSendForSigningCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2007}
     */
    contractSendForSigning(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['callback'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractSendForSigning");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2007;

        return this.apiClient.callApi(
            '/contract_session/{id}/send_for_signing', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the contractUpsale operation.
     * @callback module:api/ContractApi~contractUpsaleCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InlineResponse2003Upsale>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Register a new upsale on the contract session
     * Some of the products will automatically trigger a email with more information, and a link to the product registration. Other products, like &#39;rentadm&#39; will only be fullfilled later in the process
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject6} opts.upsale 
     * @param {module:api/ContractApi~contractUpsaleCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InlineResponse2003Upsale>}
     */
    contractUpsale(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['upsale'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractUpsale");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = [InlineResponse2003Upsale];

        return this.apiClient.callApi(
            '/contract_session/{id}/upsale', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    contractUpsales(id, opts, callback) {
      opts = opts || {};
      let postBody = opts;

      // verify the required parameter 'id' is set
      if (id === undefined || id === null) {
          throw new Error("Missing the required parameter 'id' when calling contractUpsale");
      }


      let pathParams = {
          'id': id
      };
      let queryParams = {};
      let headerParams = {};
      let formParams = {};

      let authNames = ['APIKeyHeader'];
      let contentTypes = [];
      let accepts = ['*/*'];
      let returnType = [InlineResponse2003Upsale];

      return this.apiClient.callApi(
          '/contract_session/{id}/upsales', 'POST',
          pathParams, queryParams, headerParams, formParams, postBody,
          authNames, contentTypes, accepts, returnType, callback
      );
  }

    /**
     * Callback function to receive the result of the contractUpsaleDepgarGet operation.
     * @callback module:api/ContractApi~contractUpsaleDepgarGetCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2008} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Initiate deposit warranty upsale for the contract session
     * If the contracts is setup to accept deposit warranty, stripeKey etc will be returned otherwise 403 will be returned.
     * @param {String} id 
     * @param {module:api/ContractApi~contractUpsaleDepgarGetCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2008}
     */
    contractUpsaleDepgarGet(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractUpsaleDepgarGet");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2008;

        return this.apiClient.callApi(
            '/contract_session/{id}/upsale/depgar', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the contractUpsaleDepgarPost operation.
     * @callback module:api/ContractApi~contractUpsaleDepgarPostCallback
     * @param {String} error Error message, if any.
     * @param {Array.<module:model/InlineResponse2003Upsale>} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Register a new deposit warranty upsale for the contract session
     * If the contract is setup to accept deposit warranty and valid parameters are sent 200 or 400 will be returned.
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject7} opts.depgar 
     * @param {module:api/ContractApi~contractUpsaleDepgarPostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link Array.<module:model/InlineResponse2003Upsale>}
     */
    contractUpsaleDepgarPost(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['depgar'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractUpsaleDepgarPost");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = [InlineResponse2003Upsale];

        return this.apiClient.callApi(
            '/contract_session/{id}/upsale/depgar', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the contractUpsaleHomeInsurancePost operation.
     * @callback module:api/ContractApi~contractUpsaleHomeInsurancePostCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2009} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Register a new home insurance order, and get the result of the process
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject8} opts.homeInsurance 
     * @param {module:api/ContractApi~contractUpsaleHomeInsurancePostCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2009}
     */
    contractUpsaleHomeInsurancePost(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['homeInsurance'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling contractUpsaleHomeInsurancePost");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2009;

        return this.apiClient.callApi(
            '/contract_session/{id}/upsale/home_insurance', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the createContractSession operation.
     * @callback module:api/ContractApi~createContractSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2003} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Creates a new contract session object.
     * Creates a new contract session object that the client can use to store contract session information.
     * @param {Object} opts Optional parameters
     * @param {String} opts.rentalObjectId 
     * @param {String} opts.interestManagementId 
     * @param {module:api/ContractApi~createContractSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2003}
     */
    createContractSession(opts, callback) {
        opts = opts || {};
        let postBody = null;


        let pathParams = {};
        let queryParams = {};
        let headerParams = {};
        let formParams = {
            'rental_object_id': opts['rentalObjectId'],
            'tenancy_id': opts['tenancyId'],
            'interest_management_id': opts['interestManagementId']
        };

        let authNames = ['APIKeyHeader'];
        let contentTypes = ['application/x-www-form-urlencoded'];
        let accepts = ['*/*'];
        let returnType = InlineResponse2003;

        return this.apiClient.callApi(
            '/contract_session', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getContractDownloadToken operation.
     * @callback module:api/ContractApi~getContractDownloadTokenCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2006} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns an object with a token that can be use to download a PDF-version of the contract. A url that can be used directly is also provided.
     * Returns an object with a token that can be use to download a PDF-version of the contract.
     * @param {String} id 
     * @param {module:api/ContractApi~getContractDownloadTokenCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2006}
     */
    getContractDownloadToken(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling getContractDownloadToken");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2006;

        return this.apiClient.callApi(
            '/contract_session/{id}/download_token', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the getContractSession operation.
     * @callback module:api/ContractApi~getContractSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2004} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Returns the content of a contract session
     * Returns the content of a contract session
     * @param {String} id 
     * @param {module:api/ContractApi~getContractSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2004}
     */
    getContractSession(id, callback) {
        let postBody = null;

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling getContractSession");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2004;

        return this.apiClient.callApi(
            '/contract_session/{id}', 'GET',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }

    /**
     * Callback function to receive the result of the updateContractSession operation.
     * @callback module:api/ContractApi~updateContractSessionCallback
     * @param {String} error Error message, if any.
     * @param {module:model/InlineResponse2005} data The data returned by the service call.
     * @param {String} response The complete HTTP response.
     */

    /**
     * Update a contract session, replacing the content of the contract session
     * Update a contract session, replacing the content of the contract session
     * @param {String} id 
     * @param {Object} opts Optional parameters
     * @param {module:model/InlineObject3} opts.contract 
     * @param {module:api/ContractApi~updateContractSessionCallback} callback The callback function, accepting three arguments: error, data, response
     * data is of type: {@link module:model/InlineResponse2005}
     */
    updateContractSession(id, opts, callback) {
        opts = opts || {};
        let postBody = opts['contract'];

        // verify the required parameter 'id' is set
        if (id === undefined || id === null) {
            throw new Error("Missing the required parameter 'id' when calling updateContractSession");
        }


        let pathParams = {
            'id': id
        };
        let queryParams = {};
        let headerParams = {};
        let formParams = {};

        let authNames = ['APIKeyHeader'];
        let contentTypes = [];
        let accepts = ['*/*'];
        let returnType = InlineResponse2005;

        return this.apiClient.callApi(
            '/contract_session/{id}', 'POST',
            pathParams, queryParams, headerParams, formParams, postBody,
            authNames, contentTypes, accepts, returnType, callback
        );
    }


}